import React, { useState } from 'react';
import { Image, Modal, Space, Typography } from 'antd';
import { FilePdfOutlined, FileOutlined } from '@ant-design/icons';

const { Text } = Typography;

const IMAGE_NAME_RE = /\.(png|jpe?g|gif|webp|bmp|svg)$/i;
const PDF_NAME_RE = /\.pdf$/i;

const isImageFile = (file) => {
  if (file.originFileObj?.type) return file.originFileObj.type.startsWith('image/');
  return IMAGE_NAME_RE.test(file.name || '');
};

const isPdfFile = (file) => {
  if (file.originFileObj?.type) return file.originFileObj.type === 'application/pdf';
  return PDF_NAME_RE.test(file.name || '');
};

const getFileUrl = (file) => {
  if (file.url) return file.url;
  if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
  return null;
};

/**
 * Renders Inquiry/Quote/Certificate attachments as small thumbnails — click
 * to enlarge images (antd's built-in Image preview) or open PDFs in an
 * embedded preview modal — falling back to a plain file chip for any other
 * attachment type.
 */
export default function AttachmentPreview({ files = [], thumbnailSize = 56 }) {
  const [previewPdf, setPreviewPdf] = useState(null);

  if (files.length === 0) return null;

  return (
    <>
      <Space wrap size={8}>
        {files.map((file) => {
          const url = getFileUrl(file);

          if (url && isImageFile(file)) {
            return (
              <Image
                key={file.uid}
                src={url}
                width={thumbnailSize}
                height={thumbnailSize}
                alt={file.name}
                style={{ objectFit: 'cover', borderRadius: 6, border: '1px solid #E5E9F0' }}
              />
            );
          }

          if (url && isPdfFile(file)) {
            return (
              <Space
                key={file.uid}
                size={4}
                style={{
                  border: '1px solid #E5E9F0', borderRadius: 6, padding: '4px 8px', cursor: 'pointer',
                }}
                onClick={() => setPreviewPdf({ url, name: file.name })}
              >
                <FilePdfOutlined style={{ color: '#D4380D' }} />
                <Text style={{ fontSize: 12 }}>{file.name}</Text>
              </Space>
            );
          }

          return (
            <Space
              key={file.uid}
              size={4}
              style={{ border: '1px solid #E5E9F0', borderRadius: 6, padding: '4px 8px' }}
            >
              <FileOutlined />
              <Text style={{ fontSize: 12 }}>{file.name}</Text>
            </Space>
          );
        })}
      </Space>

      <Modal
        title={previewPdf?.name}
        open={Boolean(previewPdf)}
        onCancel={() => setPreviewPdf(null)}
        footer={null}
        width="80%"
        styles={{ body: { padding: 0, height: '80vh' } }}
        destroyOnClose
      >
        {previewPdf && (
          <iframe
            src={previewPdf.url}
            title={previewPdf.name}
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        )}
      </Modal>
    </>
  );
}
